<template>
  <div class="main-container-phone">
    <div class="img-top-phone">
      <img src="@/assets/images/login/mobile/login-newbg-phone.png" class="newbg-phone clearfix" />
      <img src="@/assets/images/login/mobile/logo-phone.png" class="lgphone" />
    </div>
    <div class="content-box-phone">
      <div class="input-box-phone">
        <div class="text-top-phone">
          <div class="text-login-phone">{{ statusText }}</div>
        </div>
      </div>
      <div>
        <div v-show="status === 'login'">
          <div class="login-inner">
            <form
              autocomplete="off"
              method="post"
              data-success="@{login.redirect()}"
              action="/admin/user/page/userLogin.do"
            >
              <div class="login-item mgb20 user-phone">
                <input
                  v-model="phone"
                  type="text"
                  class="clearError"
                  placeholder="请输入手机号码"
                  maxlength="11"
                  @keyup.enter="goLogin"
                  @input="inputPhone"
                />
              </div>

              <div v-show="!isPasswordLogin" class="clearfix mgb10 safe-code-wrap">
                <div class="login-item code safe-code fl small-input">
                  <input
                    v-model="loginCode"
                    type="text"
                    class="clearError"
                    placeholder="请输入6位验证码"
                    maxlength="6"
                    @keyup.enter="goLogin"
                    @input="inputCode"
                  />
                  <div class="login-code-btn" :class="loginSendCodeTimeInfo.time ? 'disable-btn' : ''" @click="loginSendCode">
                    <span v-show="!loginSendCodeTimeInfo.time">获取验证码</span>
                    <span v-show="loginSendCodeTimeInfo.time">{{ loginSendCodeTimeInfo.time }}</span>
                  </div>
                </div>
                <input
                  class="login-hidden-input"
                  type="text"
                />
              </div>

              <div v-show="isPasswordLogin">
                <div class="login-item mgb20 user-pwd small-input">
                  <input
                    v-model="password"
                    type="password"
                    class="clearError"
                    placeholder="请输入密码"
                    maxlength="24"
                    @keyup.enter="goLogin"
                  />
                </div>

                <div class="clearfix mgb10 safe-code-wrap">
                  <div class="login-item code safe-code fl">
                    <input
                      v-model="code"
                      type="text"
                      class="clearError"
                      placeholder="请输入4位验证码"
                      maxlength="4"
                      @keyup.enter="goLogin"
                      @input="inputCode"
                    />
                  </div>
                  <div class="code-img fl mgl5">
                    <img
                      :src="codeImg"
                      class="p-code-image"
                      alt=""
                      @click="refreshCode"
                    />
                  </div>
                </div>
              </div>

              <div class="checkbox-group clearfix mgb20">
                <a class="fr login-forgetlink" @click="changeLoginType">{{ loginTypeChangeText }}</a>
              </div>
              <div>
                <div v-if="!isLoading" class="login-btn" @click="goLogin">登录</div>
                <div v-else class="login-btn login-btn-loading">登录中</div>
              </div>
            </form>
          </div>
        </div>
        <div v-show="status === 'forget'">
          <div class="login-inner">
            <form
              autocomplete="off"
            >
              <div class="login-item mgb20 user-phone">
                <input
                  v-model="forgetpwdForm.phone"
                  type="text"
                  class="clearError"
                  placeholder="请输入手机号码"
                  maxlength="11"
                  @keyup.enter="resetPwd"
                  @input="inputPwdPhone"
                />
                <a href="javascript:;" class="clearIpt j-clearIpt"><i class="gicon-remove"></i></a>
              </div>

              <div class="clearfix mgb10">
                <div class="login-item safe-code fl">
                  <input
                    v-model="forgetpwdForm.code"
                    type="text"
                    class="clearError"
                    placeholder="请输入6位验证码"
                    maxlength="6"
                    @keyup.enter="resetPwd"
                    @input="inputPwdCode"
                  />
                  <div class="ml5 fl mgl5 get-code-btn" :class="passwordSendCodeTimeInfo.time ? 'disable-btn' : ''" @click="sendCode">
                    <span v-show="!passwordSendCodeTimeInfo.time">获取验证码</span>
                    <span v-show="passwordSendCodeTimeInfo.time">{{ passwordSendCodeTimeInfo.time }}</span>
                  </div>
                </div>
              </div>

              <div class="login-item mgb20 user-pwd">
                <input
                  v-model="forgetpwdForm.password"
                  type="password"
                  class="clearError"
                  placeholder="请输入重置密码"
                  maxlength="20"
                  @keyup.enter="resetPwd"
                />
              </div>

              <div class="login-item mgb20 user-pwd">
                <input
                  v-model="forgetpwdForm.againPassword"
                  type="password"
                  class="clearError"
                  placeholder="再次确认重置密码"
                  maxlength="20"
                  @keyup.enter="resetPwd"
                />
              </div>

              <div>
                <div class="checkbox-group clearfix mgb20">
                  <a class="fr login-link" @click="gotoLogin">登录</a>
                </div>
                <div v-if="!isLoading" class="login-btn" @click="resetPwd">确认</div>
                <div v-else class="login-btn login-btn-loading">确认中</div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <img class="img-bottom-phone" src="@/assets/images/login/mobile/phone-bg-bottom.png" />
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  mixins: [mixin],
  mounted() {
    // 判断设备类型
    const ua = window.navigator.userAgent.toLocaleLowerCase()
    const isIOS = /iphone|ipad|ipod/.test(ua)
    const isAndroid = /android/.test(ua)
    const judgeDeviceType = {
      isIOS: isIOS,
      isAndroid: isAndroid
    }
    sessionStorage.removeItem('mobile-product-refresh')
    sessionStorage.removeItem('mobile-welcome-refresh')
    if (!sessionStorage.getItem('mobile-login-refresh')) {
      sessionStorage.setItem('mobile-login-refresh', '1')
      window.location.reload()
      return
    }
    // 监听输入框的软键盘弹起和收起事件
    function listenKeybord($input) {
      if (judgeDeviceType.isIOS) {
        // IOS 键盘弹起：IOS 和 Android 输入框获取焦点键盘弹起
        $input.addEventListener('focus', () => {
          // IOS 键盘弹起后操作
          document.querySelector('.img-bottom-phone').style.position = 'static'
        }, false)
        // IOS 键盘收起：IOS 点击输入框以外区域或点击收起按钮，输入框都会失去焦点，键盘会收起，
        $input.addEventListener('blur', () => {
          // IOS 键盘收起后操作
          document.querySelector('.img-bottom-phone').style.position = 'absolute'
        })
      }
      // Andriod 键盘收起：Andriod 键盘弹起或收起页面高度会发生变化，以此为依据获知键盘收起
      if (judgeDeviceType.isAndroid) {
        let originHeight = document.documentElement.clientHeight || document.body.clientHeight
        window.addEventListener('resize', () => {
          const resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
          if (originHeight < resizeHeight) {
            // Android 键盘收起后操作
            // activeElementScrollIntoView($input, 1000)
            document.querySelector('.img-bottom-phone').style.position = 'absolute'
          } else {
            // Android 键盘弹起后操作
            activeElementScrollIntoView($input, 10)
            document.querySelector('.img-bottom-phone').style.position = 'static'
          }
          originHeight = resizeHeight
        }, false)
      }
    }
    // 获取到焦点元素滚动到可视区
    function activeElementScrollIntoView(activeElement, delay) {
      const editable = activeElement.getAttribute('contenteditable')
      // 输入框、textarea或富文本获取焦点后没有将该元素滚动到可视区
      if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || editable === '' || editable) {
        setTimeout(() => {
          activeElement.scrollIntoView({ block: 'center' })
        }, delay)
      }
    }
    const $inputs = document.querySelectorAll('input')
    for (let i = 0; i < $inputs.length; i++) {
      listenKeybord($inputs[i])
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container-phone {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  .img-top-phone {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    padding-bottom: 0.24rem;
  }
  .newbg-phone {
    width: 100%;
  }
  .img-top-phone .lgphone {
    width: 0.63rem;
    height: 0.29rem;
    position: absolute;
    top: 0.3rem;
    left: 0.2rem;
  }
  .content-box-phone {
    margin: 0 auto;
  }
  .img-bottom-phone {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    margin-top: 0.64rem;
  }
}
.content-box-phone {
  .login-inner {
    margin: 0 auto;
    width: 2.5rem;
  }
  input {
    font-family: MicrosoftYaHei;
    outline: none;
    -webkit-appearance: none;
    border-radius: 0;
    border: none;
    background-color: transparent !important;
    border-bottom: 0.012rem solid rgba(151, 151, 151, 0.4);
    width: 100%;
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.14rem;
    vertical-align: bottom;
    padding: 0.06rem 0.04rem 0.08rem;
    box-sizing: border-box;
  }
  .input-box-phone {
    margin: 0 auto;
    width: 2.5rem;
  }
  .text-login-phone {
    width: 2.5rem;
    height: 0.47rem;
    font-size: 0.18rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #257efe;
    line-height: 0.47rem;
    text-align: center;
    float: left;
    margin-bottom: 0.39rem;
  }
  .text-login-phone {
    border-bottom: 1px solid rgba(37, 126, 254, 1);
  }
  .text-register-phone {
    border-bottom: 1px solid rgba(151, 151, 151, 1);
    color: #666666;
  }
  .user-phone, .user-pwd, .safe-code {
    position: relative;
    width: 2.24rem;
    border: none;
    background: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 0.25rem;
    line-height: 0.2rem;
    font-size: 0.14rem;
    margin-left: 0.26rem;
    color: #333;
    font-family: PingFangSC-Regular, PingFang SC;
    margin-bottom: 0.2rem;
  }
  .user-phone::before, .user-pwd::before, .safe-code:before {
    width: 0.17rem;
    height: 0.28rem;
    content: "";
    background-repeat: no-repeat;
    background-size: 0.17rem 0.19rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -0.26rem;

  }
  .user-phone::before {
    background-image: url('~@/assets/images/login/icon-usr.png');
  }
  .user-pwd::before {
    background-image: url('~@/assets/images/login/icon-pwd.png');
  }
  .safe-code:before {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAA0CAMAAADCKvr4AAAAn1BMVEUAAAAkfv8bgP8jf/8lfv8Wdv8kfv8lfv8kfv8jgP8kfv8lfv8kfv8lfv8lfv8lfv8lfv8lf/8lfv8kf/8jf/8kfv8kfv8lfv8lfv8kf/8lf/8lf/8kfv8kfv8lfv8lf/8lf/8mgP8kfv8lfv8kfv8jf/8mgP8lfv8lff4lf/8lfv8lf/8lfv8lf/8lf/8lfv8lfv8fff8lfv8lff4lfv+tFHSyAAAANHRSTlMA/AkM+gVP7X4V9/PpsuXUxoSbYx3gy7ijb0M0JtuokY1WcmlGOSG8npZfWj8qrHdKEMC/7v5NEgAAAl9JREFUSMeVVdeCqjAQDUWKIF1AFPvadXXv/P+33UkkSwBx43mQEE8y5cwM5BWSMMvCHZFE7ABiuJYiaxFU2EsYMMZIHJ+3I2rA0t5yB0YKiMzG9WSIK3fSf+Dr6ALCqZy+BoAwF8aLE9p2WQKFnid1zN5zKwiNpGaelzdfAQZ30QhP/faggrm3bIIoXL7j5NtBJ5rVYfx74oIeDtlS8Y9GX1SzTe7r7L6EzDFt1vlLI++hTtcmwIHgz5RIwQDwCMaoytFt1O0Dugqgf0BHqvIJ3QH4hG5K0e27/Vy4MvTCBHMmTTeo6pYsfcXUX0n6HrNKtXhm/sj7mrKVSfU2BEegq8dg0mRbrFbjWiZXoIcAEIrsJWullVAEY4GeA+K7Zkds2tzFEvPRIXhUna1T0xveRnPWEBehSwBS4gHMeNJYYOen5RFrt2mz3uckBSgaadMN2u571ujXVuAWOYj+Tpi7BXkEgBjPiAi0Z5AYIGulznnOsjJpzgQHFJvsFNBtMXkcvt2acbiFD7QrqsPnb/ogTSwAlvjYoJPiNJoz9j+tPZ/c58hQTYCTuE9TOFI7pYm+8PA88S41KpcD0kbKfdZQqYXETDKrO08ASvGePSiF8svQHbuP2XU4wWiDwRv2VAeI69e7QsunF3bJpRfEj3od/8E4sSJaYuZdf7gQypa/Cd0waklZV/66c0dOy2rWYScpb+FuDYETt+VxObuDDW3WvWhgd6Ptten7bJf038OVZzui570L6YN2VAARWMb2tPABoeRv5Z4GICK4kD9QjPSKO7wVRAL2Kcp+RuGrr/h/pGFmOT4thAIAAAAASUVORK5CYII=);
  }
  .safe-code-wrap {
    display: flex;
    .p-code-image {
      width: 1rem;
      height: 0.3rem;
      position: relative;
      top: -0.03rem;
    }
  }
  .login-code-btn, .forget-pwd-btn {
    position: absolute;
    right: 0.04rem;
    top: -2px;
    line-height: 0.3rem;
    font-size: 0.14rem;
    height: 0.3rem;
    color: #257efe;
  }
  .small-input input {
    padding-right: 0.8rem;
  }
  .checkbox-group {
    text-align: right;
  }
  .login-forgetlink, .login-link {
    line-height: 0.3rem;
    font-size: 0.14rem;
    height: 0.3rem;
    color: #257efe;
  }
  .login-btn, .get-code-btn {
    margin-top: 0.2rem;
    position: relative;
    font-size: 0.18rem;
    padding: 0.08rem 0;
    border-radius: 1rem;
    height: 0.45rem;
    font-weight: 400;
    line-height: 0.25rem;
    text-align: center;
    text-shadow: 0rem 0.01rem 0.01rem #135cc4;
    font-family: PingFangSC-Regular, PingFang SC;
    background-color: #257efe;
    color: #fff;
    cursor: pointer;
    box-shadow: 0.01rem 0.02rem 0.08rem #bfd0e9;
  }
  .login-btn:hover {
    background-color: #6699ff;
  }
  .get-code-btn {
    font-size: 0.14rem;
    padding: 0.06rem 0.08rem;
    border-radius: 0.06rem;
    margin: 0;
    height: 0.28rem;
    line-height: 0.16rem;
    white-space: nowrap;
    min-width: 0.86rem
  }
  .disable-btn {
    color: rgba(0,0,0,.4);
    background: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    cursor: not-allowed;
  }
  .login-code-btn.disable-btn {
    background: transparent;
  }
  .login-btn-loading {
    opacity: 0.6;
    cursor: not-allowed;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: color 99999s ease-out, background-color 99999s ease-out;
  }
  .login-hidden-input {
    opacity: 0;
    position: absolute;
    bottom: 100%;
    right: 0;
  }
}
</style>
<style lang="scss">
.phone-body .ant-message {
  line-height: 0.24rem;
  font-size: 0.12rem;
  top: 0.08rem;
  .ant-message-notice-content {
    padding: 0.04rem 0.08rem;
  }
}
.ant-message .anticon {
  font-size: 0.12rem;
}
@media ( orientation: landscape ){
  // 横屏CSS
  .main-container-phone {
    overflow: auto !important;
  }
  .main-container-phone .img-bottom-phone {
    position: relative !important;
    margin-top: -0.64rem !important;
  }
  .phone-body .ant-message {
    line-height: 0.14rem;
    font-size: 0.1rem;
    top: 0.08rem;
    .ant-message-notice-content {
      padding: 0.04rem 0.08rem;
    }
  }
  .ant-message .anticon {
    font-size: 0.1rem;
  }
}
</style>
